import ViewArticlesFiltered from '../implementations/View/ArticlesFiltered';
import ViewArticleHighlight from '../implementations/View/ArticleHighlight';
import ViewArticleHighlights from '../implementations/View/ArticleHighlights';
import ViewArticleRelated from '../implementations/View/ArticleRelated';
import ViewDocsByTheme from '../implementations/View/DocsByTheme';
import ViewEventsUpcoming from '../implementations/View/EventsUpcoming';
import ViewPartnersHighlights from '../implementations/View/PartnersHighlights';
import ViewPartnersOverview from '../implementations/View/PartnersOverview';
import ViewProjectsFiltered from '../implementations/View/ProjectsFiltered';
import ViewVacanciesFiltered from '../implementations/View/VacanciesFiltered';
import ViewPersonsFiltered from '../implementations/View/PersonsFiltered';
import ViewThemesOverview from '../implementations/View/ThemesOverview';
import ViewThemesByParent from '../implementations/View/ThemesByParent';
import ViewThemesRelated from '../implementations/View/ThemesRelated';
import ViewDocumentsFiltered from '../implementations/View/DocumentsFiltered';
import ViewDocumentsHighlighted from '../implementations/View/DocumentsHighlighted';
import ViewPartnersSlider from '../implementations/View/PartnersSlider';
import ViewCrisisBanner from '../implementations/View/CrisisBanner';

const mappers = {
  views_block__articles_filtered_articles_filtered: ViewArticlesFiltered,
  views_block__article_highlight: ViewArticleHighlight,
  views_block__article_highlights: ViewArticleHighlights,
  views_block__article_related: ViewArticleRelated,
  views_block__docs_by_theme: ViewDocsByTheme,
  views_block__documents_filtered_documents_filtered: ViewDocumentsFiltered,
  views_block__document_documents_highlighted: ViewDocumentsHighlighted,
  views_block__events_upcoming: ViewEventsUpcoming,
  views_block__partners_slider: ViewPartnersSlider,
  views_block__partners_highlights: ViewPartnersHighlights,
  views_block__partners_overview: ViewPartnersOverview,
  views_block__projects_filtered_projects_filtered: ViewProjectsFiltered,
  views_block__theme_by_parent: ViewThemesByParent,
  views_block__theme_related: ViewThemesRelated,
  views_block__theme_overview: ViewThemesOverview,
  views_block__vacancies_filtered_vacancies_filtered: ViewVacanciesFiltered,
  views_block__persons_filtered_persons_filtered: ViewPersonsFiltered,
  views_block__crisis_banner_block_1: ViewCrisisBanner,
};

export default mappers;
